export const BLOCK_CAUSES_LIST_KEY = 'BLOCK_CAUSES_LIST';
export const BLOCK_CAUSES_ONE_KEY = 'BLOCK_CAUSES_ONE_KEY';
